import { dateByTimezoneTransform, sortDateStr } from "lib/table/tableTransforms.js";

const headerTypes = [
	{
		type: "date",
		width: 120,
		fixed: true,
		transform: dateByTimezoneTransform,
	},
	{
		type: "title",
		width: 6,
		fixed: false,
		html: true,
	},
	{
		type: "number",
		width: 120,
		fixed: true,
		reverseSort: true,
	},
	{
		type: "default",
		width: 4,
		fixed: false,
	},
];

export const mediaHeaderTypes = [
	{
		type: "relevancy",
		width: 105,
		fixed: true,
		minWidth: 550,
	},
	{
		type: "pubdate",
		width: 120,
		fixed: true,
		transform: dateByTimezoneTransform,
		sortColumn: sortDateStr,
	},
	{
		type: "title",
		width: 7,
		fixed: false,
		html: true,
		disableSort: true,
	},
	{
		type: "outlet",
		width: 4,
		fixed: false,
		minWidth: 440,
		disableSort: true,
	},
	{
		type: "sourceCountry",
		width: 120,
		fixed: true,
		minWidth: 700,
		disableSort: true,
	},
	{
		type: "default",
		width: 4,
		fixed: false,
	},
];

export default headerTypes;
